import { DataManager } from "@syncfusion/ej2-data";
import { WebApiV4Adaptor } from "../adaptors/WebApiV4Adaptor";
import { GetToken, GetExpiresAtToken } from "./helpers";
import { useDueDatesAuth } from "../hooks/useDueDatesAuth";

const GetAuthorizationHeader = async (signinSilent, tenantId) => {
  const currentTime = Math.floor(Date.now() / 1000);

  if (tenantId !== null && signinSilent) {
    if (currentTime > GetExpiresAtToken()) {
      const refreshedUser = await signinSilent();

      sessionStorage.setItem("token", refreshedUser.access_token);
      sessionStorage.setItem("expires_at", refreshedUser.expires_at);
      sessionStorage.setItem("refresh_token", refreshedUser.refresh_token);

      return refreshedUser.access_token;
    }

    return GetToken();
  }

  return "";
};

export class AppDataManager extends DataManager {
  constructor(
    url,
    signinSilent,
    dateParse = false,
    beforeExecuteQuery = null,
    enabled = true
  ) {
    const { TenantId } = useDueDatesAuth();
    const token = GetAuthorizationHeader(signinSilent, TenantId);

    super({
      url: `${import.meta.env.PUBLIC_APIGATEWAY_URL}/duedates/${url}`,
      adaptor: new WebApiV4Adaptor(),
      headers: [{ Authorization: token }]
    });

    this.signinSilent = signinSilent;
    this.dateParse = dateParse;
    this.beforeExecuteQuery = beforeExecuteQuery;
    this.enabled = enabled;
  }

  async executeQuery(query, done, fail, always) {
    if (this.enabled) {
      if (
        this.dataSource.headers.find((x) =>
          Object.prototype.hasOwnProperty.call(x, "Authorization")
        )
      ) {
        var auth = this.dataSource.headers.find((x) =>
          Object.prototype.hasOwnProperty.call(x, "Authorization")
        );
        const token = await GetAuthorizationHeader(this.signinSilent);
        auth.Authorization = `Bearer ${token}`;
      }

      if (this.beforeExecuteQuery) {
        await this.beforeExecuteQuery(response);
      }

      const response = await super.executeQuery(query, done, fail, always);

      // The checkbox filter popup reads `actual` (the raw, unprocessed response
      // body) instead of `result` while its search box has text, because the
      // adaptor reports itself as ODataV4 — see
      // CheckBoxFilterBase.executeQueryOperations. Our API wraps rows in
      // { Items, Count }, so that path hands the popup an object it cannot
      // iterate and the list renders empty. Drop it so the grid falls back to
      // the result WebApiV4Adaptor already unwrapped.
      if (response && typeof response === "object") delete response.actual;

      return response;
    } else return new Response();
  }
}
